import { INPUT } from '$gbusiness/enums';
import InputRowModel from '$gbusiness/models/inputRow';
import { addYears } from 'date-fns';

export const ORDER_EDIT_FORM = ({ settings, shippingOptions }): Array<InputRowModel> => [
  {
    items: [
      ...(settings?.manualDeliveryDate
        ? [
            {
              label: 'SCREEN.ORDER.DELIVERED_DATE',
              value: 'deliveredDate',
              input: INPUT.DATE,
              maxDate: addYears(new Date(), 1),
              gridSize: 6,
            },
          ]
        : []),
      {
        label: 'SCREEN.ORDER.SHIP_VIA',
        value: 'shippingId',
        input: INPUT.SELECT,
        rows: 4,
        gridSize: 6,
        options: shippingOptions,
      },
      {
        label: 'SCREEN.ORDER.NOTE',
        value: 'note',
        input: INPUT.TEXTAREA,
        rows: 4,
        gridSize: 12,
      },
    ],
  },
];

export const ORDER_DELIVERY_FORM = ({ users }): Array<InputRowModel> => [
  {
    items: [
      {
        label: 'SCREEN.ORDER.DELIVERED_DATE',
        value: 'deliveredDate',
        input: INPUT.DATE,
        maxDate: addYears(new Date(), 1),
        gridSize: 12,
      },
      {
        label: 'SCREEN.ORDER.DELIVERED_BY',
        value: 'deliveredBy',
        input: INPUT.AUTOCOMPLETE,
        disableFastField: true,
        gridSize: 12,
        config: {
          freeSolo: true,
          data: users.map((user) => user.name),
        },
      },
    ],
  },
];

export default ORDER_EDIT_FORM;
